import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import ErrorBoundary from './components/ErrorBoundary';
import DomainHealthCheck from './components/DomainHealthCheck';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Chat from './pages/Chat';
import Dashboard from './pages/Dashboard';
import Assessments from './pages/Assessments';
import Assessment from './pages/Assessment';
import AssessmentResponse from './pages/AssessmentResponse';
import Meditation from './pages/Meditation';
import Journal from './pages/Journal';
import PeerSupport from './pages/PeerSupport';
import ForumDetail from './pages/ForumDetail';
import TherapistHandover from './pages/TherapistHandover';
import Transparency from './pages/Transparency';
import Subscription from './pages/Subscription';
import Profile from './pages/Profile';
import Landing from './pages/Landing';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import HelpCenter from './pages/HelpCenter';
import GroupTherapy from './pages/GroupTherapy';
import GroupCircleSession from './pages/GroupCircleSession';
import Dream from './pages/Dream';
import DreamDetail from './pages/DreamDetail';
import VerifyEmail from './pages/VerifyEmail';
// import Shiller from './pages/Shiller'; // Commented out - can be used later


import PrivateRoute from './components/PrivateRoute';
import PeerSupportRedirect from './components/PeerSupportRedirect';
import TrialGuard from './components/TrialGuard';



function App() {
  // Feature flags - set to false to hide features temporarily
  const SHOW_GROUP_THERAPY = false;

  return (
    <ErrorBoundary>
      <DomainHealthCheck>
        <AuthProvider>
          <SubscriptionProvider>
            <Router>
              <div className="App min-h-screen bg-primary-50">
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<Landing />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/help-center" element={<HelpCenter />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                
                {/* Redirect old peer support routes to new structure */}
                <Route path="/peer-support/forum/:forumId" element={<PeerSupportRedirect />} />
                
                {/* Protected routes with layout */}
                <Route path="/app" element={<PrivateRoute><Layout /></PrivateRoute>}>
                  <Route index element={<TrialGuard><Home /></TrialGuard>} />
                  <Route path="chat/:therapistId" element={<TrialGuard><Chat /></TrialGuard>} />
                  <Route path="dashboard" element={<TrialGuard><Dashboard /></TrialGuard>} />
          
                  <Route path="assessments" element={<TrialGuard><Assessments /></TrialGuard>} />
                  <Route path="assessment/:assessmentId" element={<TrialGuard><Assessment /></TrialGuard>} />
                  <Route path="assessment-response/:responseId" element={<TrialGuard><AssessmentResponse /></TrialGuard>} />
                  <Route path="meditation" element={<TrialGuard><Meditation /></TrialGuard>} />
                  <Route path="journal" element={<TrialGuard><Journal /></TrialGuard>} />
                  <Route path="peer-support" element={<TrialGuard><PeerSupport /></TrialGuard>} />
                  <Route path="peer-support/forum/:forumId" element={<TrialGuard><ForumDetail /></TrialGuard>} />
                  {SHOW_GROUP_THERAPY && (
                    <>
                      <Route path="group-therapy" element={<TrialGuard><GroupTherapy /></TrialGuard>} />
                      <Route path="group-therapy/circle/:circleId" element={<TrialGuard><GroupCircleSession /></TrialGuard>} />
                    </>
                  )}
                  <Route path="dream" element={<TrialGuard><Dream /></TrialGuard>} />
                  <Route path="dream/:dreamId" element={<TrialGuard><DreamDetail /></TrialGuard>} />
                  {/* <Route path="shiller" element={<TrialGuard><Shiller /></TrialGuard>} /> */} {/* Commented out - can be used later */}

                  <Route path="therapist-handover" element={<TrialGuard><TherapistHandover /></TrialGuard>} />
                  <Route path="transparency" element={<TrialGuard><Transparency /></TrialGuard>} />

                  <Route path="subscription" element={<Subscription />} />
                  <Route path="profile" element={<TrialGuard><Profile /></TrialGuard>} />
                </Route>
              </Routes>
            </div>
          </Router>
        </SubscriptionProvider>
      </AuthProvider>
      </DomainHealthCheck>
    </ErrorBoundary>
  );
}

export default App;
